import styled from "styled-components";

export const TabContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1.5fr);
  gap: 1.5rem;
  width: 100%;
  margin: auto;
  label {
    width: 100%;
    input {
      padding-left: 10px;
      background: #fff;
    }
    select {
      width: 100%;
      background: #e5eff2;
    }
    textarea {
      width: 100%;
      resize: none;
      background: #e5eff2;
      padding: 1rem;
    }
  }
`;

export const ThankyouHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-self: start;
  padding-top: 1rem;
  color: #101e8e;
  background: #e0eedc;
  width: 100%;
`;

export const ThankyouMessage = styled.div`
  display: flex;
  margin: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #101e8e;
`;
